var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 1.5H11.25L15.75 6V15C15.75 15.825 15.075 16.5 14.25 16.5H5.25C4.425 16.5 3.75 15.825 3.75 15V12.0768C4.18326 11.8875 4.68052 11.7816 5.25 11.8117V15H14.25V6.75H10.5V3H5.25V6.08485C4.77242 6.18337 4.25528 6.36148 3.75 6.58631V3C3.75 2.175 4.425 1.5 5.25 1.5Z",
    fill: "#F2F4F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.625 7.25V5.25L10.125 8.75L6.625 12.25V10.2C4.125 10.2 2.375 11 1.125 12.75C1.625 10.25 3.125 7.75 6.625 7.25Z",
    fill: "#F2F4F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrDraft);
export default __webpack_public_path__ + "static/media/str_draft.74cc652b5a769ccdfb81274f9d088793.svg";
export { ForwardRef as ReactComponent };